/* eslint-disable no-script-url */
import React, { useMemo, useState, useCallback } from 'react';
import PropTypes from 'prop-types';

export const BulkMMAConvertError = ({
  show, inlineErrors, i18n, errorCount,
}) => {
  const [showErrorGrid, setShowErrorGrid] = useState(false);
  const errorCountString = i18n.getString('BulkEdit_InlineError_ErrorCount').replace('{0}', errorCount);
  const errorCountLinkText = useMemo(() => {
    if (showErrorGrid) {
      return i18n.getString('BulkEdit_InlineError_HideErrorLink');
    }
    return i18n.getString('BulkEdit_InlineError_ErrorLink').replace('{0}', errorCount);
  }, [errorCount, i18n, showErrorGrid]);
  const errorsGrids = useMemo(() => [i18n.getString(_TL_('Ad')), i18n.getString(_TL_('Error'))], [i18n]);

  const onToggleErrorGrid = useCallback(() => {
    setShowErrorGrid(!showErrorGrid);
  }, [showErrorGrid]);

  if (!show) {
    return null;
  }

  return (
    <div className="panel-footer">
      <div className="error">{errorCountString}</div>
      <a className="errorCountLink" href="javascript:void(0)" onClick={onToggleErrorGrid}>{errorCountLinkText}</a>
      <br />
      {showErrorGrid && (
        <div className="previewTable grid">
          <table>
            <thead>
              <tr className="grid-header-row">
                {errorsGrids.map(item => (
                  <th key={item} className="grid-header-cell grid-disabledsort">
                    <div className="grid-header-textcontainer">
                      <a className="grid-header-text">{item}</a>
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {inlineErrors.map(item => (
                <tr key={item.name} className="grid-row">
                  <td className="grid-cell">
                    <div className="grid-content-container">{item.name}</div>
                  </td>
                  <td className="grid-cell">
                    <div className="grid-content-container">{item.error}</div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

BulkMMAConvertError.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  errorCount: PropTypes.number.isRequired,
  show: PropTypes.bool.isRequired,
  inlineErrors: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    error: PropTypes.string,
  })).isRequired,
};

BulkMMAConvertError.defaultProps = {
};
